import FormRenderer from '../../../../../forms/FormRenderer'
import { FormRender } from '../../../../../forms/FormRenderer/types'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import { InputTableLeftColumnChange } from '../types'

interface InputTableLeftColumnFormProps {
    form: FormRender,
    handleChange: InputTableLeftColumnChange,
    headerData?: TwinDictionary
    children?: React.ReactNode
}

const InputTableLeftColumnForm: React.FC<InputTableLeftColumnFormProps> = ({form,handleChange, headerData, children}) => {
    const parsedFields = renderHeaderElements(form, handleChange, headerData)
    return (<FormRenderer sections={parsedFields} className='overflow-x-auto gap-y-0 auto-rows-min' allSectionsClassName={'mt-19'} >{children}</FormRenderer>)
}

export const renderHeaderElements = (form: FormRender, handleChange: InputTableLeftColumnChange, headerData?: TwinDictionary) => {
    const id = headerData?.['id']
    let result: FormRender = []
    for (const sectionKey in form) {
        const section = form[sectionKey]
        result.push({
            ...section,
            className: section.className ?? 'gap-x-19',
            elements: []
        })
        for (const itemKey in section.elements) {
            const item = { ...form[sectionKey].elements[itemKey] } as any
            const { name, onChange } = item
            const value = headerData?.[String(name)]
            result[sectionKey].elements.push({
                ...item,
                onChange: async (value: any) => { await handleChange(id, String(name), value); await onChange?.(value) },
                value: item.value ?? item.defaultValue ?? value
            })
        }
    }
    return [...result]
}

export default InputTableLeftColumnForm